import {
  Avatar,
  Button,
  Card,
  Collapse,
  Dialog,
  Grid,
  List,
  Paper,
  Stack,
  Table,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Loading from 'assets/images/loading.png';
import userIcon from 'assets/svg/userIcon.png';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useContext, useEffect, useRef, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import { useLocation } from 'react-router-dom';
import noPhotoAvailableImage from 'assets/images/noPhotoAvailableImage.png';
import {
  poppins400,
  poppins500,
  poppins600,
  poppins700,
} from 'theme/common.style';
import Air from 'assets/images/Air.png';
import Exchange from 'assets/images/Exchange.png';
import Man from 'assets/images/Man.png';
import Offer from 'assets/images/Offer.png';
import MediaQuery from 'react-responsive';
import { Box } from '@mui/system';
import { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import { Ended, Stage1, Stage2, Stage2Final } from 'component/Common/StageTags';
import { useTheme } from '@emotion/react';
import {
  getApiCall,
  getBuyerIndividualData,
  getFollowRequest,
  postApiCall,
  Moxoseparationinlisting,
} from 'api/apiService';
import PropertyTimer from 'component/PropertyTime/PropertyTimer';
import {
  BUYER_UPDATEAUCTION,
  CREATE_BINDER_WITH_AGENT,
  GET_BINDERID,
  GET_DEPOSIT,
  USER_TYPE,
} from 'constant/app.config';
import moment from 'moment';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import './MarketStyle.css';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import Moxochat from 'component/Moxochat/Moxochat';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { HighStar } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails';
import { highStarStyle } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails.style';
import Swal from 'sweetalert2';
import { MarketInvitePopup } from './MarketInvitePopup';
import MarketGallery from './MarketGallery';
import {
  Shield,
  Dot,
  Location,
  Bathroom,
  Bedroom,
  GreenDot,
  Clock,
  BedroomWhite,
  BathroomWhite,
  Carparking,
  Warning,
  CarparkingWhite,
  Expand,
} from './Marketplaceicons';
import { MarketPlace, HighestOffer1 } from './MarketPlace';
import Commonfile from './Commonfile';
import { AgentComp } from './AgentComp';
import DepositDueNow from 'modules/private/BuyerDashboard/DepositDueNow';
import DepositOverdue from 'modules/private/BuyerDashboard/DepositOverdue';
import DepositOverdueRestrictedPopup from 'modules/private/BuyerDashboard/DepositOverdueRestrictedPopup';
import DepositPaymentDetailsNew from 'component/BuyerRegistration/components/DepositPaymentDetailsNew';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import IdenticalSuggestionBuyerone from 'modules/BuyerMarketplace/IdenticalSuggestionBuyerone';
import IdenticalSuggestionBuyertwo from 'modules/BuyerMarketplace/IdenticalSuggestionBuyertwo';
import SiderComponent from 'component/sider';
import MarketSkeleton from './MarketSkeleton';
import StickyAddressBar from './StickyAddressBar';
import DocumentHub from 'component/FileManager/DocumentHub';
import BuyerProtectionDialog from './BuyerProtectionDialog';
import WalkScore from './WalkScoreView';
import NameTooltip from 'component/Common/NameTooltip';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

const Market = () => {
  const {
    realTimeLog,
    setIschatopen,
    openlogin,
    setOpenlogin,
    isOpenFileManager,
    setIsOpenFileManager,
  } = useContext(datacontext);
  const [openBuyerProtection, setOpenBuyerProtection] = useState(false);
  const { collapsed } = useContext(PropertyContext);
  const stickyAnchorRef = useRef(null);
  const stickyAnchorTimerRef = useRef(null);
  const marketScrollRef = useRef(null);
  const [scrollToMakeOffer, setScrollToMakeOffer] = useState(false);
  const scrollTotabRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const pageRef = useRef(null);
  const STICKY_TOP = isOpenFileManager ? 200 : 70;
  const stickySentinelRef = useRef(null);
  const imageRef = useRef(null);

  const onScrollfunc = () => {
    if (!imageRef.current) return;

    const imageRect = imageRef.current.getBoundingClientRect();

    // When bottom of image reaches sticky header (70px from top)
    if (imageRect.bottom <= STICKY_TOP) {
      setIsStickyAddress(true);
      setIsSticky(true);
    } else {
      setIsStickyAddress(false);
      setIsSticky(false);
    }
  };

  const [activityupdate, setActivityupdate] = useState(false);
  const location = useLocation();
  const [sharedpage, setSharedpage] = useState(false);
  const { propertyIds } = location.state ? location.state : sharedpage;
  const [showActivateTrade, setShowActivateTrade] = useState(false);
  const [tabData, setTabDAta] = useState('1');
  const [newTabData, setNewTabData] = useState(false);
  const [hideOthers, SetHideOthers] = useState(false);
  const [showPropertyTimer, setShowPropertyTimer] = useState(false);
  const [offerHistoryState, setOfferHistoryState] = useState(false);
  const [hideActivateTrade, setHideActivateTrade] = useState(false);
  const [isStickyTwo, setIsStickyTwo] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isStickyAddress, setIsStickyAddress] = useState(false);
  const [isStickyTimer, setIsStickyTimer] = useState(false);
  const [isStickyTimerStage, setIsStickyTimerStage] = useState(false);
  const [hideConfirmBox, setHideConfirmBox] = useState(false);
  const params = useParams();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [auctionConfirm, setAuctionConfirm] = useState(false);
  const [auctionConfirmLoading, setAuctionConfirmLoading] = useState(false);
  const [auctionDeclineLoading, setAuctionDeclineLoading] = useState(false);
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const buyerId = userDetail?.userId;
  const { isScrolling, isBinderChatOpen } = useContext(PropertyContext);
  const fromSavedSearch = location.state?.fromSavedSearch;
  const savedSearchTradeAssistLog = location.state?.savedSearchTradeAssistLog;

  const [descriptionShowMore, setDescriptionShowMore] = useState(false);
  const characterThreshold = 300;

  const [remainingHoursTimeBlink, setRemainingHoursTimeBlink] = useState();
  const [stageTwoBlink, setStageTwoBlink] = useState();

  // this state check Active Trade Assist, "Active"

  const [showActivateTradeForSharePage, setShowActivateTradeForSharePage] =
    useState(false);

  const scrollPercentageData = location?.state?.scrollPercentageValue || {};
  const activeTabDataFromSharePage = location?.state?.activeTabData || {};

  // from share page login update "pages" using useEffect

  const { openMakeOfferST2Mobile } = location.state || {};

  useEffect(() => {
    const root = document.getElementById('root');
    root?.classList.add('highest-offer-active');

    return () => {
      root?.classList.remove('highest-offer-active');
    };
  }, []);

  const handleMakeOfferClick = () => {
    setTabDAta('4');
    setNewTabData(true);
    SetHideOthers(false);
    setShowPropertyTimer(false);
    setOfferHistoryState(false);
  };

  useEffect(() => {
    if (auctionConfirmLoading || auctionDeclineLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [auctionConfirmLoading, auctionDeclineLoading]);

  useEffect(() => {
    if (openMakeOfferST2Mobile) {
      const timer = setTimeout(() => {
        handleMakeOfferClick();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (location.state?.showActivateTradeForSharePageValue == true) {
      setShowActivateTrade(true);
      setHideActivateTrade(false);
      setHideConfirmBox(false);
      setTabDAta(activeTabDataFromSharePage);
    }
  }, [location.state?.showActivateTradeForSharePageValue]);

  // from share page login update "scroll" using useEffect

  useEffect(() => {
    if (scrollPercentageData !== undefined) {
      const handleScroll = () => {
        window.scrollTo(0, parseInt(scrollPercentageData, 10));
      };
      setTimeout(handleScroll, 100);
      window.addEventListener('load', handleScroll);
      return () => window.removeEventListener('load', handleScroll);
    }
  }, [location.state]);

  const handleDescriptionShowMore = () => {
    setDescriptionShowMore((prev) => !prev);
  };

  const activityfun = () => {
    setActivityupdate(!activityupdate);
  };

  let propertyId = params?.propertyId;

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const scrollThreshold = 100;
    setIsZoomedOut(scrollY > scrollThreshold);
  };
  const handleScrollTimer = () => {
    if (stickyAnchorTimerRef.current) {
      setIsStickyTimer(window.scrollY >= 650);
      setIsStickyTimerStage(window.scrollY >= 1050);
    }
  };
  const [getBuyerIndividualValue, setGetBuyerIndividualValue] = useState({});
  const [firstIdentical, setFirstIdentical] = useState(null);

  const dateupdated = moment(
    getBuyerIndividualValue?.PropertyDetails?.highestOfferLastUpdated
  ).format('DD-MM-YYYY');
  const leaseExpiryDate = moment(
    getBuyerIndividualValue?.PropertyDetails?.propertyOtherDetails?.leaseExpiry
  ).format('DD-MM-YYYY');
  const formattedDateTime = getBuyerIndividualValue?.nextInspection?.dateTime
    ? dayjs(getBuyerIndividualValue.nextInspection.dateTime).format(
        'DD MMM YYYY - hh:mm A'
      )
    : 'No Upcoming Inspection';
  const formattedDateTimesmday = getBuyerIndividualValue?.nextInspection
    ?.dateTime
    ? dayjs(getBuyerIndividualValue.nextInspection.dateTime).format(
        'dddd, DD MMMM YYYY'
      )
    : 'No Upcoming Inspection';
  const formattedDateTimesmtime =
    getBuyerIndividualValue?.nextInspection?.dateTime &&
    dayjs(getBuyerIndividualValue.nextInspection.dateTime).format('hA') +
      ' - ' +
      dayjs(getBuyerIndividualValue.nextInspection.dateTime)
        .add(30, 'minute')
        .format('h:mm A');

  const propertyDetails = getBuyerIndividualValue?.PropertyDetails;

  const isAuction =
    propertyDetails?.generalCampaignDetails?.generalCampaign === 'Auction' ||
    propertyDetails?.campaignType === 'Off Market';

  const [isFollowLoading, setIsFollowLoading] = useState(false);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const handleFollowClick = () => {
    const isFollowStatus =
      getBuyerIndividualValue?.PropertyDetails?.isFollowed == 0 ? 1 : 0;
    setIsFollowLoading(true);
    getFollowRequest(propertyId, 'Buyer', isFollowStatus)
      .then((res) => {
        if (res?.status == '1') {
          if (isNotEmptyArray(res?.dataForWatchlistAgentAck)) {
            Moxoseparationinlisting(
              'dataForWatchlistAgentAck',
              res?.dataForWatchlistAgentAck
            );
          }
          const currentUrl = window.location.href;
          getBuyerIndividualData(
            propertyId,
            currentUrl,
            userDetail?.primaryUserType
          ).then((res) => {
            if (res?.status == '1') {
              setGetBuyerIndividualValue(res);
            } else {
              setGetBuyerIndividualValue({});
            }
            setIsFollowLoading(false);
          });
        } else {
          setIsFollowLoading(false);
        }
      })
      .catch(() => {
        setIsFollowLoading(false);
      });
  };
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname, window.location.pathname]);

  useEffect(() => {
    if (realTimeLog) {
      groupIt();
    }
  }, [realTimeLog]);

  const groupIt = async () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes('share') && !realTimeLog) {
      if (userDetail?.primaryUserType != 'Buyer') {
        setSharedpage(true);
      } else {
        const currentPath = history.location.pathname;
        const newPath = currentPath.replace('/share/', '/market/');
        history.push(newPath);
      }
    }
    await getBuyerIndividualData(
      propertyId,
      currentUrl,
      userDetail?.primaryUserType
    )
      .then((res) => {
        if (res?.status == '1') {
          setGetBuyerIndividualValue(res);
        } else {
          setGetBuyerIndividualValue({});
        }
      })
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    groupIt();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('scroll', handleScrollTimer);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollTimer);
    };
  }, []);

  useEffect(() => {
    if (getBuyerIndividualValue?.isIdenticalPopup == 1) {
      if (getBuyerIndividualValue?.isFirstIdentical == 1) {
        setFirstIdentical(1);
      } else {
        setFirstIdentical(0);
      }
    } else {
      setFirstIdentical(null);
    }
  }, [getBuyerIndividualValue?.isIdenticalPopup]);

  const ImageArray =
    getBuyerIndividualValue?.PropertyDetails?.propertyMedia?.filter((item) => {
      return item?.mediaType === 'Banner';
    }) ?? [];

  const propertyImages = ImageArray.map((item) => {
    return {
      original: item?.propertyMedia,
      thumbnail: item?.propertyMedia,
    };
  });

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslgup = useMediaQuery(theme.breakpoints.up('lg'));
  const matches1330 = useMediaQuery(theme.breakpoints.down(1330));
  const matchesbet = useMediaQuery(theme.breakpoints.down(1700));
  const matchestable800 = useMediaQuery(theme.breakpoints.down(800));
  const matchestable400 = useMediaQuery(theme.breakpoints.down(400));
  const matchestable500 = useMediaQuery(theme.breakpoints.down(500));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslgIsSti = useMediaQuery(theme.breakpoints.down(1919));
  const matcheslgIsSticky = useMediaQuery(theme.breakpoints.up(1330));
  const [highestOfferBox, setHighestOfferBox] = useState(false);
  const matchesxl = useMediaQuery(theme.breakpoints.down('xl'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchesB = useMediaQuery(theme.breakpoints.between(1536, 1636));
  const [blurComp, setBlurComp] = useState(true);
  const [confirmAcceptLog, setConfirmAcceptLog] = useState();
  const makeOfferRef = useRef(null);
  const [openShare, setOpenShare] = useState(false);
  const [isMakeanOffer, setIsMakeanOffer] = useState(false);
  const userType = userDetail?.primaryUserType;

  const directcomm = (agentId) => {
    if (buyerId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${buyerId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        if (resp?.data?.binderId) {
          onShowChat(resp?.data?.binderId);
        } else {
          let parameters = {
            agentId: agentId,
            buyerId: buyerId,
            propertyId: propertyId,
          };
          postApiCall(CREATE_BINDER_WITH_AGENT, parameters).then((resp) => {
            onShowChat(resp?.data?.binderId);
          });
        }
      });
    }
  };

  const handleClickOpen = () => {
    setOpenShare(true);
  };

  const handleClose = (value) => {
    setOpenShare(false);
  };

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };

  const videoTour = propertyDetails?.propertyMedia?.find(
    (item) => item.mediaType === 'VideoTour'
  );

  const video360 = propertyDetails?.propertyMedia?.find(
    (item) => item.mediaType === 'Video360'
  );
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  const currentPage = window.location.pathname;

  const [open, setOpen] = useState(false);

  const handleClickImage = (event) => {
    event.stopPropagation();
    setOpen(true);
  };

  const tradeAssistLog =
    fromSavedSearch && savedSearchTradeAssistLog != undefined
      ? savedSearchTradeAssistLog
      : getBuyerIndividualValue?.PropertyDetails?.tradeAssistLog;

  useEffect(() => {
    if (tradeAssistLog != 1) {
      setShowActivateTrade(false);
    } else {
      setShowActivateTrade(true);
    }
  }, [tradeAssistLog]);

  // buyer Acution confirmation check
  useEffect(() => {
    if (
      getBuyerIndividualValue?.isAuction == 1 &&
      getBuyerIndividualValue?.auctionStatus == 'Pending'
    ) {
      setAuctionConfirm(true);
    }
  }, [getBuyerIndividualValue]);
  // buyer action table post api function
  const handleAuctionConfirm = (value) => {
    if (value == 0) {
      setAuctionDeclineLoading(true);
    } else if (value == 1) {
      setAuctionConfirmLoading(true);
    }
    let input = {
      propertyId:
        getBuyerIndividualValue?.PropertyDetails?.property?.propertyId,
      status: value == 0 ? 'Declined' : value == 1 ? 'Confirmed' : null,
    };

    postApiCall(BUYER_UPDATEAUCTION, input)
      .then((res) => {
        if (res?.data?.status == '1') {
          setAuctionConfirmLoading(false);
          setAuctionDeclineLoading(false);
          setAuctionConfirm(false);
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setAuctionDeclineLoading(false);
          setAuctionConfirmLoading(false);
          setAuctionConfirm(false);
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => {
        setAuctionConfirmLoading(false);
        setAuctionDeclineLoading(false);
        setAuctionConfirm(false);
      });
  };

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (sharedpage) {
      setOpenlogin(!openlogin);
    } else {
      setAnchorEl(event.currentTarget);
      setDialogOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };

  const [isZoomedOut, setIsZoomedOut] = useState(false);
  const [isZooming, setIsZooming] = useState(false);

  useEffect(() => {
    const handleZooming = () => {
      setIsZooming(true);

      setTimeout(() => {
        setIsZooming(false);
      }, 3000);
    };

    if (isZoomedOut) {
      handleZooming();
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isZoomedOut]);

  const [depositeopen, setDepositeopen] = useState(false);
  const [getDeposit, setGetDeposit] = useState(null);
  const [hasFetchedDeposit, setHasFetchedDeposit] = useState(false);
  const GetDeposit = () => {
    if (hasFetchedDeposit) return;
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      setGetDeposit(res?.data);
      setShowActivateTrade(true);
      setDepositeopen(true);
      setHasFetchedDeposit(true);
    });
  };

  const [paymentPop, setPaymentPop] = useState(false);
  const [openDueNow, setOpenDueNow] = useState(null);
  const [openOverDueNow, setOpenOverDueNow] = useState(null);
  const [openOverDueRestrict, setOpenOverDueRestrict] = useState(null);

  useEffect(() => {
    const trigger = location?.state?.triggerGetDeposit === true;
    const winner = getBuyerIndividualValue?.PropertyDetails;
    const flag = winner?.flagDepositPaymentStatus;

    if (trigger && !hasFetchedDeposit) {
      setShowActivateTrade(true);
      GetDeposit();
      window.history.replaceState({}, document.title);

      return;
    }

    if (
      winner?.isWinner === 1 &&
      winner?.isWinnerId === buyerId &&
      (flag == 'Processing' || flag == 'Completed')
    ) {
      setOpenDueNow(null);
      setOpenOverDueNow(null);
      setOpenOverDueRestrict(null);
      return;
    }

    if (
      !trigger &&
      winner?.isWinner === 1 &&
      winner?.isWinnerId === buyerId &&
      flag != 'Processing' &&
      flag != 'Completed'
    ) {
      const currentTime = dayjs().tz('Australia/Sydney');
      const winnerTime = dayjs.tz(winner.winnerAt, 'Australia/Sydney');
      const diffInMinutes = currentTime.diff(winnerTime, 'minute');

      if (diffInMinutes < 60) {
        setOpenDueNow(winner);
        setOpenOverDueNow(null);
        setOpenOverDueRestrict(null);
      } else if (diffInMinutes >= 60 && diffInMinutes < 1440) {
        setOpenDueNow(null);
        setOpenOverDueNow(winner);
        setOpenOverDueRestrict(null);
      } else if (diffInMinutes >= 1440) {
        setOpenDueNow(null);
        setOpenOverDueNow(null);
        setOpenOverDueRestrict(winner);
      }
    }
    window.history.replaceState({}, document.title);
  }, [
    location?.state?.triggerGetDeposit,
    getBuyerIndividualValue?.PropertyDetails?.flagDepositPaymentStatus,
    buyerId,
    realTimeLog,
    hasFetchedDeposit,
  ]);

  const handleDepositDialogClose = () => {
    setDepositeopen(false);
    const winner = getBuyerIndividualValue?.PropertyDetails;
    const currentTime = dayjs().tz('Australia/Sydney');
    const winnerTime = dayjs.tz(winner?.winnerAt, 'Australia/Sydney');
    const diffInMinutes = currentTime.diff(winnerTime, 'minute');
    if (
      winner?.isWinner == 1 &&
      winner?.isWinnerId == buyerId &&
      winner?.flagDepositPaymentStatus != 'Processing' &&
      winner?.flagDepositPaymentStatus != 'Completed' &&
      diffInMinutes >= 1440
    ) {
      setOpenOverDueRestrict(winner);
    }
  };

  return (
    <div ref={pageRef} className="market-page" onScroll={onScrollfunc}>
      {' '}
      {loader ? (
        <>
          <div ref={stickySentinelRef} style={{ height: 1 }} />

          <MarketSkeleton />
        </>
      ) : (
        <>
          <Box>
            <>
              {openDueNow &&
                !isOpenFileManager &&
                openDueNow?.flagDepositPaymentStatus != 'Processing' &&
                openDueNow?.flagDepositPaymentStatus != 'Completed' && (
                  <DepositDueNow
                    open={true}
                    onClose={() => setOpenDueNow(null)}
                    streetName={openDueNow?.propertyAddress?.streetName}
                    propertyId={openDueNow?.property?.propertyId}
                    individualPage={true}
                    getBuyerIndividualValue={getBuyerIndividualValue}
                    setPaymentPop={setPaymentPop}
                    flagSign={openDueNow?.flagDepositPayment}
                    flagSignStatus={openDueNow?.flagDepositPaymentStatus}
                    setShowActivateTrade={setShowActivateTrade}
                  />
                )}

              {openOverDueNow &&
                !isOpenFileManager &&
                openOverDueNow?.flagDepositPaymentStatus != 'Processing' &&
                openOverDueNow?.flagDepositPaymentStatus != 'Completed' && (
                  <DepositOverdue
                    open={true}
                    onClose={() => setOpenOverDueNow(null)}
                    streetName={openOverDueNow?.propertyAddress?.streetName}
                    propertyId={openOverDueNow?.property?.propertyId}
                    individualPage={true}
                    getBuyerIndividualValue={getBuyerIndividualValue}
                    setPaymentPop={setPaymentPop}
                    flagSign={openOverDueNow?.flagDepositPayment}
                    flagSignStatus={openOverDueNow?.flagDepositPaymentStatus}
                    setShowActivateTrade={setShowActivateTrade}
                  />
                )}

              {openOverDueRestrict &&
                openOverDueRestrict?.flagDepositPaymentStatus != 'Processing' &&
                openOverDueRestrict?.flagDepositPaymentStatus !=
                  'Completed' && (
                  <DepositOverdueRestrictedPopup
                    open={true}
                    onClose={() => setOpenOverDueRestrict(null)}
                    streetName={
                      openOverDueRestrict?.propertyAddress?.streetName
                    }
                    propertyId={openOverDueRestrict?.property?.propertyId}
                    individualPage={true}
                    getBuyerIndividualValue={getBuyerIndividualValue}
                    binderId={openOverDueRestrict?.agentBuyerBinderId}
                    setPaymentPop={setPaymentPop}
                    flagSign={openOverDueRestrict?.flagDepositPayment}
                    flagSignStatus={
                      openOverDueRestrict?.flagDepositPaymentStatus
                    }
                    setShowActivateTrade={setShowActivateTrade}
                  />
                )}
              <DepositPaymentDetailsNew
                open={depositeopen}
                setDepositeopen={handleDepositDialogClose}
                data={getDeposit}
                getBuyerIndividualValue={getBuyerIndividualValue}
                setPaymentPop={setPaymentPop}
              />
            </>
            <Box
              sx={{
                position: 'sticky',
                top: 70,
                zIndex: 1200,
                background: '#F7F8F7',
                display: matchessm ? 'none' : 'block',
              }}
            >
              {isStickyAddress && (
                <SiderComponent isStickyAddress={isStickyAddress} />
              )}
              <StickyAddressBar
                isStickyAddress={isStickyAddress}
                isBinderChatOpen={isBinderChatOpen}
                matchessm={matchessm}
                getBuyerIndividualValue={getBuyerIndividualValue}
                showActivateTrade={showActivateTrade}
                sharedpage={sharedpage}
                setOpenlogin={setOpenlogin}
                openlogin={openlogin}
                directcomm={directcomm}
                setIsHovered={setIsHovered}
                handleMouseLeave={handleMouseLeave}
                handleClick={handleClick}
                isDialogOpen={isDialogOpen}
                setDialogOpen={setDialogOpen}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                isHovered={isHovered}
                isSticky={isSticky}
                matcheslg={matcheslg}
              />
              {!isBinderChatOpen &&
                !currentPage.includes('/share') &&
                getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' &&
                getBuyerIndividualValue?.PropertyDetails?.timerStatus !=
                  'End' && (
                  <Box
                    sx={{
                      width: '100%',
                      background: '#FF5050',
                      color: '#FFFFFF',
                      display: !isStickyAddress ? 'none' : 'block',
                      height: '42px',
                      padding: '10px',
                      position: 'fixed',
                      top: 160,
                      left: 0,
                      zIndex: 100,
                      textAlign: 'center',
                      fontSize: '18px',
                      fontWeight: 600,
                      fontFamily: 'poppins',
                    }}
                  >
                    <Stack
                      direction={'row'}
                      alignItems={'center'}
                      justifyContent={'center'}
                    >
                      <Box sx={{ marginTop: '-6px' }}>
                        Stage 2 Commenced &nbsp;
                      </Box>
                      <Box>
                        <PropertyTimer
                          propertyData={
                            getBuyerIndividualValue?.PropertyDetails
                          }
                          upperCountDown={'upperCountDown'}
                          isStickyStageTwo={true}
                        />
                      </Box>

                      {getBuyerIndividualValue?.PropertyDetails?.stage ==
                        'ST2' &&
                        getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                          'Pause' && (
                          <Box sx={{ marginTop: '-3px' }}>
                            <PauseIcon width={20} height={20} />
                          </Box>
                        )}
                    </Stack>
                  </Box>
                )}
            </Box>

            <Box
              ref={imageRef}
              sx={{
                height: matchessm ? '530px' : matchesmd ? '550px' : '959px',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <Typography
                sx={{
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  width: '100%',
                  height: matchessm ? '530px' : matchesmd ? '550px' : '959px',
                }}
                onClick={handleClickImage}
              >
                {/* Custom styles for bullets in a style tag */}
                <style>
                  {`
          .image-gallery-bullets .image-gallery-bullets-container{
            margin: 5px 0;
      width:"100%;
      display: flex;
      justify-content: center;
      text-align: ${matchessm ? 'right' : 'center !important'};
          },
      .image-gallery-bullet {
        cursor: pointer;
      },
.container-class .image-gallery-bullets {
    z-index: 1;
}
        `}
                </style>

                <ImageGallery
                  items={propertyImages}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  showBullets={propertyImages.length > 1 ? true : false}
                  lazyLoad={true}
                  showIndex={false}
                  showThumbnails={false}
                  showNav={false}
                  useBrowserFullscreen={true}
                  disableSwipe={false}
                  renderItem={(item) => (
                    <div
                      style={{
                        padding: 0,
                        margin: 0,
                        width: '100%',
                        height: matchessm
                          ? '530px'
                          : matchesmd
                          ? '550px'
                          : '959px',
                      }}
                    >
                      <img
                        src={item.original}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noPhotoAvailableImage;
                        }}
                        alt={item.originalAlt}
                        style={{
                          width: '100%',
                          height: matchessm
                            ? '530px'
                            : matchesmd
                            ? '550px'
                            : '959px',
                          objectFit: 'cover',
                          margin: 0,
                          padding: 0,
                        }}
                      />
                    </div>
                  )}
                />
              </Typography>

              <MarketGallery
                open={open}
                setOpen={setOpen}
                openlogin={openlogin}
                setOpenlogin={setOpenlogin}
                sharedpage={sharedpage}
                getBuyerIndividualValue={getBuyerIndividualValue}
              />

              <Grid
                container
                sx={{
                  position: 'absolute',
                  top: '0px',
                  marginTop: matchessm ? '30px' : '80px',
                  justifyContent: 'space-between',
                  padding: matchessm
                    ? '0px'
                    : matcheslg
                    ? '10px'
                    : !matcheslg && matchesxl
                    ? '0 40px 20px 106px'
                    : '0 145px 20px 106px',
                }}
              >
                {/* offer closes in starts  */}
                {!matchessm && (
                  <Grid
                    item
                    sx={{
                      borderRadius: '5px',
                      alignContent: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.77)',
                      marginTop: !matcheslg && '15px',
                      p: '15px',
                      justifyContent: 'space-between',
                      opacity: isStickyTwo ? '0' : '1',
                      visibility: isSticky ? 'hidden' : 'visible',
                      display: isStickyAddress && !showActivateTrade && 'none',
                    }}
                  >
                    <Grid
                      sx={{
                        height: '17%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Clock />
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '500 !important',
                            fontSize: '16px',
                            color: '#212529',
                            marginLeft: '11px',
                          }}
                        >
                          Offers close in:
                        </Typography>
                      </Box>
                      <Grid
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '2px',
                          alignContent: 'center',
                          paddingLeft: '10px',
                        }}
                      >
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus == 'Pause' && (
                          <Box sx={{ paddingTop: '3px' }}>
                            <PauseIcon width={21} height={21} />
                          </Box>
                        )}
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End' && (
                          <Ended
                            matches450={matches450}
                            matchesB={matchesB}
                            customStyles={{
                              borderRadius: '2px',
                              height: '20px',
                              padding: '1px 12px',
                            }}
                          />
                        )}
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus !== 'End' &&
                          getBuyerIndividualValue?.PropertyDetails?.stage ===
                            'ST1' && (
                            <Stage1
                              matches450={matches450}
                              matchesB={matchesB}
                              customStyles={{
                                borderRadius: '2px',
                                height: '20px',
                                padding: '1px 12px',
                              }}
                            />
                          )}
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus !== 'End' &&
                          getBuyerIndividualValue?.PropertyDetails?.stage ===
                            'ST2' &&
                          getBuyerIndividualValue?.PropertyDetails?.isReset ==
                            '1' && (
                            <Stage2Final
                              matches450={matches450}
                              matchesB={matchesB}
                              customStyles={{
                                borderRadius: '2px',
                                height: '20px',
                                padding: '1px 12px',
                                animation:
                                  stageTwoBlink == 'ST2' &&
                                  remainingHoursTimeBlink > 0 &&
                                  remainingHoursTimeBlink <= 3
                                    ? 'blink 1s infinite'
                                    : getBuyerIndividualValue?.PropertyDetails
                                        ?.stage == 'ST2' &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog != null &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog?.isAccept == '0' &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog?.status == 'viewed'
                                    ? 'blink 1s 10'
                                    : 'none',
                              }}
                            />
                          )}
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus !== 'End' &&
                          getBuyerIndividualValue?.PropertyDetails?.stage ===
                            'ST2' &&
                          getBuyerIndividualValue?.PropertyDetails?.isReset !=
                            '1' && (
                            <Stage2
                              matches450={matches450}
                              matchesB={matchesB}
                              customStyles={{
                                borderRadius: '2px',
                                height: '20px',
                                padding: '1px 12px',
                                animation:
                                  stageTwoBlink == 'ST2' &&
                                  remainingHoursTimeBlink > 0 &&
                                  remainingHoursTimeBlink <= 3
                                    ? 'blink 1s infinite'
                                    : getBuyerIndividualValue?.PropertyDetails
                                        ?.stage == 'ST2' &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog != null &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog?.isAccept == '0' &&
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.stageTwoViewLog?.status == 'viewed'
                                    ? 'blink 1s 10'
                                    : 'none',
                              }}
                            />
                          )}
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus !== 'End' &&
                          getBuyerIndividualValue?.PropertyDetails?.stage !==
                            'ST1' &&
                          getBuyerIndividualValue?.PropertyDetails?.stage !==
                            'ST2' && (
                            <Typography
                              sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                height: '20px',
                                padding: '3px 12px',
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '600 !important',
                                fontSize: '12px',
                                color: '#FFFFFF',
                                borderRadius: '2px',
                                bgcolor:
                                  getBuyerIndividualValue?.PropertyDetails
                                    ?.property?.status == 'Sold'
                                    ? '#F93939'
                                    : '#529AEE',
                              }}
                            >
                              {getBuyerIndividualValue?.PropertyDetails
                                ?.property?.status == 'Sold'
                                ? 'Sold'
                                : 'Unpublished'}
                            </Typography>
                          )}
                      </Grid>
                    </Grid>

                    <Box sx={{ marginTop: '10px', minWidth: '100%' }}>
                      <PropertyTimer
                        propertyData={getBuyerIndividualValue?.PropertyDetails}
                        upperCountDown={'upperCountDown'}
                        setRemainingHoursTimeBlink={setRemainingHoursTimeBlink}
                        setStageTwoBlink={setStageTwoBlink}
                        isReset={
                          getBuyerIndividualValue?.PropertyDetails?.isReset
                        }
                      />
                    </Box>
                  </Grid>
                )}
                {matchessm && (
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'fixed',
                        top: isScrolling ? 0 : 23,
                        marginTop: isScrolling ? '0px' : '50px',
                        width: '100%',
                        zIndex: 100,
                        width: '100%',
                        background: 'white',
                      }}
                    >
                      <AgentComp
                        matchessm={matchessm}
                        matchestable400={matchestable400}
                        isStickyAddress={isStickyAddress}
                        showActivateTrade={showActivateTrade}
                        getBuyerIndividualValue={getBuyerIndividualValue}
                        sharedpage={sharedpage}
                        setOpenlogin={setOpenlogin}
                        openlogin={openlogin}
                        directcomm={directcomm}
                        setIsHovered={setIsHovered}
                        handleMouseLeave={handleMouseLeave}
                        handleClick={handleClick}
                        isDialogOpen={isDialogOpen}
                        setDialogOpen={setDialogOpen}
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        isHovered={isHovered}
                        isSticky={isSticky}
                      />
                    </Box>

                    <Grid
                      item
                      sx={{
                        backgroundColor: matchessm
                          ? 'rgba(255, 255, 255, 0.4)'
                          : 'rgba(255, 255, 255, 0.77)',
                        width: '100%',
                        p: '15px 15px 0 15px',
                        justifyContent: 'space-between',
                        marginTop: '105px',
                      }}
                    >
                      <Grid
                        sx={{
                          height: '17%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          spacing={1}
                        >
                          <Clock />
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '500 !important',
                              fontSize: '16px',
                              color: '#212529',
                            }}
                          >
                            Offers close in:
                          </Typography>
                        </Stack>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2px',
                            alignItems: 'center',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'Pause' && (
                            <Box>
                              <PauseIcon width={21} height={21} />
                            </Box>
                          )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus === 'End' && (
                            <Ended
                              matches450={matches450}
                              matchesB={matchesB}
                              customStyles={{
                                borderRadius: '2px',
                                height: '20px',
                                padding: '1px 12px',
                              }}
                            />
                          )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus !== 'End' &&
                            getBuyerIndividualValue?.PropertyDetails?.stage ===
                              'ST1' && (
                              <Stage1
                                matches450={matches450}
                                matchesB={matchesB}
                                customStyles={{
                                  borderRadius: '2px',
                                  height: '20px',
                                  padding: '1px 12px',
                                }}
                              />
                            )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus !== 'End' &&
                            getBuyerIndividualValue?.PropertyDetails?.stage ===
                              'ST2' &&
                            getBuyerIndividualValue?.PropertyDetails?.isReset ==
                              '1' && (
                              <Stage2Final
                                matches450={matches450}
                                matchesB={matchesB}
                                customStyles={{
                                  borderRadius: '2px',
                                  height: '20px',
                                  padding: '1px 12px',
                                }}
                              />
                            )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus !== 'End' &&
                            getBuyerIndividualValue?.PropertyDetails?.stage ===
                              'ST2' &&
                            getBuyerIndividualValue?.PropertyDetails?.isReset !=
                              '1' && (
                              <Stage2
                                matches450={matches450}
                                matchesB={matchesB}
                                customStyles={{
                                  borderRadius: '2px',
                                  height: '20px',
                                  padding: '1px 12px',
                                }}
                              />
                            )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus !== 'End' &&
                            getBuyerIndividualValue?.PropertyDetails?.stage !==
                              'ST1' &&
                            getBuyerIndividualValue?.PropertyDetails?.stage !==
                              'ST2' && (
                              <Typography
                                sx={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  textAlign: 'center',
                                  height: '20px',
                                  margin: '10px',
                                  padding: '3px 12px',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '600 !important',
                                  fontSize: '12px',
                                  color: '#FFFFFF',
                                  borderRadius: '2px',
                                  bgcolor:
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.status == 'Sold'
                                      ? '#F93939'
                                      : '#529AEE',
                                }}
                              >
                                {getBuyerIndividualValue?.PropertyDetails
                                  ?.property?.status == 'Sold'
                                  ? 'Sold'
                                  : 'Unpublished'}
                              </Typography>
                            )}
                        </Grid>
                      </Grid>

                      <Box
                        sx={{
                          marginTop: '10px',
                          minWidth: '100%',
                          height: '70px',
                        }}
                      >
                        <PropertyTimer
                          propertyData={
                            getBuyerIndividualValue?.PropertyDetails
                          }
                          upperCountDown={'upperCountDown'}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                )}
                {/* offer closes in end */}

                {/* web page sticky - property details end */}

                {/* web page sticky - trade assist*/}
                {!matchesmd && !isSticky && (
                  <AgentComp
                    isStickyAddress={isStickyAddress}
                    showActivateTrade={showActivateTrade}
                    getBuyerIndividualValue={getBuyerIndividualValue}
                    sharedpage={sharedpage}
                    setOpenlogin={setOpenlogin}
                    openlogin={openlogin}
                    directcomm={directcomm}
                    setIsHovered={setIsHovered}
                    handleMouseLeave={handleMouseLeave}
                    handleClick={handleClick}
                    isDialogOpen={isDialogOpen}
                    setDialogOpen={setDialogOpen}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    isHovered={isHovered}
                    isSticky={isSticky}
                  />
                )}
                {/* web page sticky - trade assist end */}
              </Grid>

              <Grid
                sx={{
                  width: '90%',
                  pointerEvents: matchessm ? 'none' : 'auto',
                  marginLeft: matcheslg ? '15px' : '106px',
                  flexDirection: 'column',
                  position: 'absolute',
                  top: matchessm ? '400px' : matchesmd ? '450px' : '750px',
                }}
              >
                <Stack
                  sx={{
                    width: 'min-content',
                    whiteSpace: 'nowrap',
                    height: '33px',
                    width: '115px',
                    borderRadius: '5px',
                    bgcolor:
                      getBuyerIndividualValue?.PropertyDetails?.property
                        ?.status == 'Sold'
                        ? '#F93939'
                        : getBuyerIndividualValue?.PropertyDetails
                            ?.campaignType == 'Off Market'
                        ? '#f39800'
                        : getBuyerIndividualValue?.PropertyDetails
                            ?.campaignType == 'Auction'
                        ? '#383837'
                        : '#08A742',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#FFFFFF',
                      textAlign: 'center',
                      borderRadius: '5px',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.property
                      ?.status == 'Sold'
                      ? 'Sold'
                      : getBuyerIndividualValue?.PropertyDetails?.campaignType}
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                  }}
                >
                  {!matchessm && (
                    <Typography
                      sx={{
                        ...poppins700,
                        fontSize: '48px',
                        color: '#FFFFFF',
                        borderRadius: '5px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: '100%',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {
                        getBuyerIndividualValue?.PropertyDetails?.property
                          ?.heading
                      }
                    </Typography>
                  )}
                  <Tooltip
                    title={
                      getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }
                    placement="bottom"
                    disableInteractive
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: '#fafafa',
                          boxShadow: '0px 2px 20px lightgray',
                          color: 'black',
                          padding: '10px',
                          fontFamily: 'poppins !important',
                          fontSize: '14px',
                          maxWidth: '1000px',
                          lineHeight: 1.5,
                          color: '#666666',
                        },
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        height: '40px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'left',
                        alignItems: 'center',
                        margin: matchessm ? '10px 0px 5px 0px' : '10px 0',
                        overflow: 'hidden',
                        maxWidth: '100%',
                      }}
                      gap={1}
                    >
                      <Box>
                        <Location />
                      </Box>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: matchesmd ? '20px' : '24px',
                          color: '#FFFFFF',
                          textAlign: 'left',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          width: '100%',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {
                          getBuyerIndividualValue?.PropertyDetails
                            ?.propertyAddress?.streetName
                        }
                      </Typography>
                    </Stack>
                  </Tooltip>
                </Stack>
                <Grid
                  sx={{
                    display: matchessm ? 'flex' : 'none',
                    justifyContent: 'start',
                    gap: '20px',
                  }}
                >
                  <Box
                    sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}
                  >
                    <BedroomWhite />
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '16px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.propertyOtherDetails?.bedRoomCount || '-'}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}
                  >
                    <BathroomWhite />
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '16px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.propertyOtherDetails?.bathRoomCount || '-'}
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}
                  >
                    <CarparkingWhite />
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '16px',
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.propertyOtherDetails?.otherCarParking || '-'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <div ref={stickySentinelRef} style={{ height: 1 }} />

            <Grid
              container
              backgroundColor={'#FFFFFF'}
              sx={{
                padding: matchesmd && '0 15px',
                justifyContent: matchesmd ? 'center' : 'space-between',
                overflow: 'hidden',
              }}
            >
              {!isStickyAddress && (
                <SiderComponent isStickyAddress={isStickyAddress} />
              )}
              {isOpenFileManager ? (
                <Grid
                  item
                  sx={{
                    marginLeft: matchessm
                      ? '0%'
                      : currentPage.includes('/share')
                      ? '5%'
                      : '8%',
                    width: matchessm
                      ? '100%'
                      : currentPage.includes('/share') && matches1330
                      ? '100%'
                      : '70%',
                    marginTop: !matchesmd ? '100px' : '20px',
                    overflow: 'auto',
                  }}
                >
                  <DocumentHub
                    propertyAddress={
                      getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                        ?.streetName
                    }
                    userType={userDetail?.primaryUserType}
                    getListInfo={groupIt}
                  />
                </Grid>
              ) : (
                <>
                  {(!showActivateTrade ||
                    hideActivateTrade ||
                    hideConfirmBox) && (
                    <>
                      {' '}
                      <Grid
                        item
                        sx={{
                          marginLeft: matchessm
                            ? '0%'
                            : currentPage.includes('/share')
                            ? '5%'
                            : '8%',
                          width: matchessm
                            ? '100%'
                            : currentPage.includes('/share') && matches1330
                            ? '100%'
                            : '70%',
                          marginTop: !matchesmd ? '50px' : '20px',
                          overflow: 'auto',
                        }}
                      >
                        <Box>
                          <Commonfile
                            getBuyerIndividualValue={getBuyerIndividualValue}
                            matchessm={matchessm}
                            openShare={openShare}
                            matchesmd={matchesmd}
                            handleClickOpen={handleClickOpen}
                            matches500={matchestable500}
                            handleFollowClick={handleFollowClick}
                            matcheslgIsSti={matcheslgIsSti}
                            isFollowLoading={isFollowLoading}
                            sharedpage={sharedpage}
                            openlogin={openlogin}
                            setOpenlogin={setOpenlogin}
                            handleClose={handleClose}
                            matcheslgIsSticky={matcheslgIsSticky}
                            matcheslgup={matcheslgup}
                            highestOfferBox={highestOfferBox}
                            setHighestOfferBox={setHighestOfferBox}
                            setHideActivateTrade={setHideActivateTrade}
                            setShowActivateTrade={setShowActivateTrade}
                            tradeassist={false}
                          />

                          <Grid
                            container
                            sx={{
                              background: '#FFFFFF',
                            }}
                          >
                            <Grid container spacing={'2'}>
                              <Grid
                                item
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  width: '100%',
                                  marginTop: '35px',
                                }}
                              >
                                <Grid
                                  item
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '25px',
                                    flexWrap: matchestable800 && 'wrap',
                                    width: '100%',
                                  }}
                                >
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      gap: '10px',
                                      flexDirection: matchessm && 'column',
                                      width: '100%',
                                    }}
                                  >
                                    {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
                                      <Stack
                                        onClick={() => (
                                          setShowActivateTradeForSharePage(
                                            true
                                          ),
                                          setShowActivateTrade(true),
                                          setHideActivateTrade(false),
                                          setHideConfirmBox(false),
                                          setTabDAta('1')
                                        )}
                                        sx={{
                                          minWidth: matchessm && '100%',
                                          height: '63px',
                                          background:
                                            'linear-gradient(135deg, #6D3FF2 0%, #3D7DF2 100%)',
                                          boxShadow:
                                            '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                          borderRadius: '5px',
                                          p: !matchessm && '9px 0px 9px 0px',
                                          cursor: 'pointer',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: 'Poppins !important',
                                            fontStyle: 'normal !important',
                                            fontWeight: '400 !important',
                                            fontSize: matchessm
                                              ? '20px'
                                              : '24px',
                                            margin: 'auto',
                                            color: '#FFFFFF',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            padding: !matchessm && '0px 20px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          Property Hub
                                        </Typography>
                                      </Stack>
                                    )}
                                    <Stack
                                      sx={{
                                        minWidth: matchessm && '100%',
                                        height: '63px',
                                        background: '#FFFFFF',
                                        border: '1px solid #A505FF',
                                        borderRadius: '5px',
                                        p: !matchessm && '9px 0px 9px 0px',
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: 'Poppins !important',
                                          fontStyle: 'normal !important',
                                          fontWeight: '400 !important',
                                          fontSize: matchessm ? '20px' : '24px',
                                          margin: 'auto',
                                          color: '#555252',
                                          textAlign: 'center',
                                          padding: !matchessm && '0px 20px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        Terms & Conditions
                                      </Typography>
                                    </Stack>
                                  </Grid>
                                  <Grid
                                    item
                                    sx={{
                                      display: matchessm ? 'none' : 'flex',
                                      justifyContent: 'space-between',
                                      margin: matchestable500 && 'auto',
                                      gap: '15px',
                                    }}
                                  >
                                    <Box sx={{ display: 'flex', gap: '15px' }}>
                                      <Bedroom />
                                      <Typography
                                        sx={{
                                          ...poppins500,
                                          fontSize: '24px',
                                          color: '#000000',
                                          textAlign: 'center',
                                        }}
                                      >
                                        {getBuyerIndividualValue
                                          ?.PropertyDetails
                                          ?.propertyOtherDetails
                                          ?.bedRoomCount || '-'}
                                      </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: '15px' }}>
                                      <Bathroom />
                                      <Typography
                                        sx={{
                                          ...poppins500,
                                          fontSize: '24px',
                                          color: '#000000',
                                          textAlign: 'center',
                                        }}
                                      >
                                        {getBuyerIndividualValue
                                          ?.PropertyDetails
                                          ?.propertyOtherDetails
                                          ?.bathRoomCount || '-'}
                                      </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: '15px' }}>
                                      <Carparking />
                                      <Typography
                                        sx={{
                                          ...poppins500,
                                          fontSize: '24px',
                                          color: '#000000',
                                          textAlign: 'center',
                                        }}
                                      >
                                        {getBuyerIndividualValue
                                          ?.PropertyDetails
                                          ?.propertyOtherDetails
                                          ?.otherCarParking || '-'}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Stack
                              sx={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: matcheslg ? 'column' : 'row',
                                marginTop: '35px',
                              }}
                            >
                              <Grid sx={{ flexDirection: 'row' }}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: 500,
                                    fontSize: matchessm ? '20px' : '24px',
                                    color: '#000000',
                                  }}
                                >
                                  Auction: &nbsp;
                                  {matchessm && <br />}
                                </Typography>
                                {getBuyerIndividualValue?.PropertyDetails
                                  ?.auctionDetails ? (
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: matchessm ? 300 : 500,
                                      fontSize: matchessm ? '16px' : '24px',
                                      color: '#000000',
                                    }}
                                  >
                                    {
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.auctionDetails?.campaignvenue
                                    }{' '}
                                    {moment(
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.auctionDetails?.campaignAuctionDate,
                                      'YYYY-MM-DD'
                                    ).format('DD') +
                                      ' ' +
                                      moment(
                                        getBuyerIndividualValue?.PropertyDetails
                                          ?.auctionDetails?.campaignAuctionDate,
                                        'YYYY-MM-DD'
                                      ).format(matchessm ? 'MMMM' : 'MMM') +
                                      ' ' +
                                      moment(
                                        getBuyerIndividualValue?.PropertyDetails
                                          ?.auctionDetails?.campaignAuctionDate,
                                        'YYYY-MM-DD'
                                      ).format('YYYY')}
                                    {' - '}
                                    {moment(
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.auctionDetails?.campaignAuctionTime,
                                      'HH:mm:ss'
                                    ).format('HH:mm A')}
                                  </Typography>
                                ) : (
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: matchessm ? 300 : 500,
                                      fontSize: matchessm ? '16px' : '24px',
                                      color: '#000000',
                                    }}
                                  >
                                    No auction found
                                  </Typography>
                                )}
                              </Grid>
                              <Typography
                                sx={{
                                  display: 'flex',
                                  flexDirection: matchessm ? 'column' : 'row',
                                  alignItems: 'start',
                                  gap: '5px',
                                  marginTop: matchessm && '40px',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: matchessm ? '20px' : '24px',
                                  color: '#000000',
                                }}
                              >
                                {' '}
                                Next Inspection:
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: matchessm ? 300 : 500,
                                    fontSize: matchessm ? '16px' : '24px',
                                    color: '#000000',
                                  }}
                                >
                                  {getBuyerIndividualValue?.nextInspection
                                    ?.dateTime ? (
                                    <>
                                      {moment(
                                        getBuyerIndividualValue.nextInspection
                                          .dateTime
                                      ).format('dddd, Do MMMM YYYY')}

                                      <br />

                                      {moment(
                                        getBuyerIndividualValue.nextInspection
                                          .dateTime
                                      ).format('hh:mm A')}
                                      {' - '}
                                      {moment(
                                        getBuyerIndividualValue.nextInspection
                                          .dateTime
                                      )
                                        .add(
                                          Number(
                                            getBuyerIndividualValue
                                              ?.nextInspection?.duration || 30
                                          ),
                                          'minutes'
                                        )
                                        .format('hh:mm A')}
                                    </>
                                  ) : (
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: matchessm ? 300 : 500,
                                        fontSize: matchessm ? '16px' : '24px',
                                        color: '#000000',
                                      }}
                                    >
                                      No next inspection found
                                    </Typography>
                                  )}
                                </Typography>
                              </Typography>
                            </Stack>

                            <Grid
                              container
                              sx={{
                                marginTop: '30px',
                                display: 'flex',
                                flexDirection: matchessm
                                  ? 'column-reverse'
                                  : 'column',
                                gap: '10px',
                              }}
                            >
                              <Grid>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: matchessm ? '16px' : '20px',
                                    color: '#666666',
                                  }}
                                >
                                  {getBuyerIndividualValue?.PropertyDetails
                                    ?.property?.propertyTypeName || '-'}
                                </Typography>
                              </Grid>
                              <Grid>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '600 !important',
                                    fontSize: matchessm ? '24px' : '32px',
                                    color: '#000000',
                                  }}
                                >
                                  {
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.heading
                                  }
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Stack
                            sx={{
                              background: '#FFFFFF',
                              borderRadius: '10px',
                              marginTop: '5px',
                              marginBottom: '40px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: matchessm ? '20px' : '24px',
                                color: '#000000',
                                marginTop: '23px',
                              }}
                            >
                              Description
                            </Typography>
                            {matchessm ? (
                              <>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: matchessm ? '16px' : '20px',
                                    color: '#666666',
                                    marginTop: '10px',
                                    textAlign: 'justify',
                                    display: '-webkit-box',
                                    WebkitLineClamp: descriptionShowMore
                                      ? 'initial'
                                      : getBuyerIndividualValue?.PropertyDetails
                                          ?.property?.propertyDescription
                                          ?.length < characterThreshold
                                      ? 'initial'
                                      : 7, // Limit to 7 lines initially
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.propertyDescription
                                  }
                                </Typography>
                                {getBuyerIndividualValue?.PropertyDetails
                                  ?.property?.propertyDescription?.length >
                                  characterThreshold && (
                                  <Button
                                    onClick={handleDescriptionShowMore}
                                    sx={{
                                      color: '#6f29d2',
                                      textTransform: 'none',
                                      fontSize: matchessm ? '16px' : '20px',
                                      marginTop: '10px',
                                      fontWeight: '400',
                                      fontFamily: 'Poppins',
                                      border: '1px solid #6f29d2',
                                      width: 'fit-content',
                                    }}
                                  >
                                    {descriptionShowMore ? 'Less' : 'Read More'}
                                  </Button>
                                )}
                              </>
                            ) : (
                              <Typography
                                component="pre"
                                sx={{
                                  fontFamily: 'poppins', // ✅ Spacing and dot alignment
                                  whiteSpace: 'pre-wrap', // ✅ Preserves line breaks and spaces
                                  fontSize: '16px',
                                  color: '#666666',
                                  marginTop: '20px',
                                }}
                              >
                                {getBuyerIndividualValue?.PropertyDetails
                                  ?.property?.propertyDescription || ''}
                              </Typography>
                            )}
                          </Stack>

                          <Table>
                            {getBuyerIndividualValue?.PropertyDetails?.property
                              ?.propertyStrata != null && (
                              <Grid>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '500 !important',
                                    fontSize: matchesbet ? '18px' : '24px',
                                    color: '#000000',
                                  }}
                                >
                                  Strata&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  : &nbsp;
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontSize: '18px',
                                      color: '#666666',
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: '20px',
                                        fontWeight: 500,
                                      }}
                                    >
                                      $
                                    </span>
                                    {
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.property?.propertyStrata
                                    }
                                  </Typography>
                                </Typography>
                              </Grid>
                            )}
                            <Grid>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: matchesbet ? '18px' : '24px',
                                  color: '#000000',
                                }}
                              >
                                Council Rate : &nbsp;
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontSize: '18px',
                                    color: '#666666',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '20px',
                                      fontWeight: 500,
                                    }}
                                  ></span>
                                  {
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.propertyCouncilRate
                                  }
                                </Typography>
                              </Typography>
                            </Grid>
                            <Grid>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: matchesbet ? '18px' : '24px',
                                  color: '#000000',
                                }}
                              >
                                Water Rate&nbsp;&nbsp;&nbsp; : &nbsp;
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontSize: '18px',
                                    color: '#666666',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '20px',
                                      fontWeight: 500,
                                    }}
                                  ></span>
                                  {
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.propertyWaterRate
                                  }
                                </Typography>
                              </Typography>
                            </Grid>
                          </Table>
                          <Grid
                            container
                            sx={{
                              background: '#FFFFFF',
                              borderRadius: '10px',
                              paddingTop: '10px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: matchessm ? '20px' : '24px',
                                color: '#000000',
                                marginTop: '23px',
                              }}
                            >
                              Features
                            </Typography>

                            <Grid
                              container
                              spacing={2} // consistent gap between items
                              sx={{
                                marginTop: '20px',
                                width: '100%',
                              }}
                            >
                              {getBuyerIndividualValue?.PropertyDetails
                                ?.propertyFeature?.length > 0 ? (
                                getBuyerIndividualValue?.PropertyDetails?.propertyFeature?.map(
                                  (item, index) => (
                                    <Grid
                                      key={index}
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3} // 4 per row on large, 3 on medium, 2 on small
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={2}
                                      >
                                        <img
                                          src={Air}
                                          alt="Air"
                                          style={{
                                            width: '30px',
                                            height: '30px',
                                          }}
                                        />
                                        <Typography
                                          sx={{
                                            fontFamily: 'Poppins !important',
                                            fontStyle: 'normal !important',
                                            fontWeight: '400 !important',
                                            fontSize: matchessm
                                              ? '16px'
                                              : '20px',
                                            color: '#666666',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {item?.featureName}
                                        </Typography>
                                      </Stack>
                                    </Grid>
                                  )
                                )
                              ) : (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={3}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={2}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '400 !important',
                                        fontSize: matchessm ? '16px' : '20px',
                                        color: '#666666',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      No features available
                                    </Typography>
                                  </Stack>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            sx={{
                              width: '100%',
                              borderRadius: '10px',
                              background: '#FFFFFF',
                              paddingTop: '40px',
                            }}
                          >
                            <Typography
                              sx={{
                                width: '83px',
                                height: '36px',
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: matchessm ? '20px' : '24px',
                                color: '#000000',
                                marginBottom: '20px',
                              }}
                            >
                              Details
                            </Typography>
                            <Grid
                              container
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                gap: '20px',
                              }}
                            >
                              <Grid
                                item
                                sm={5.5}
                                sx={{
                                  height: 'auto',
                                  borderRadius: '20px',
                                  background: '#F8F8F8',
                                  marginTop: '3px',
                                  minWidth: matchestable800 && '100%',
                                  p: '25px 30px 25px 30px',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'15px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    PropertyID
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.property?.propertyUniqueId
                                    }
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Price
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {isAuction
                                      ? 'Auction'
                                      : getBuyerIndividualValue?.PropertyDetails
                                          ?.property?.propertyPrice || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Property Size
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.propertyLandSize || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Bedrooms
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.bedRoomCount ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Bathrooms
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.bathRoomCount ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Deposit
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.deposit || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Pool Size
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.poolSize || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Last Remodal Year
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.lastRemodelYear ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                              </Grid>
                              <Grid
                                item
                                sm={5.5}
                                sx={{
                                  height: 'auto',
                                  borderRadius: '20px',
                                  background: '#F8F8F8',
                                  minWidth: matchestable800 && '100%',
                                  p: '25px 30px 25px 30px',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'15px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Garage
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.garageCount ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Garage Size
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.otherCarParking ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Year Built
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.yearOfBuild ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Property Type
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                      textAlign: 'right',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.propertyTypeName || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Property Status
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    08
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Amenities
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.amenities || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Additional Rooms
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.additionalRooms ||
                                      '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    borderBottom: '0.5px solid #C4C4C4',
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  alignItems={'center'}
                                  padding={'5px 10px'}
                                  marginTop={'10px'}
                                  sx={{ justifyContent: 'space-between' }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#112347',
                                    }}
                                  >
                                    Equipment
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '16px' : '20px',
                                      color: '#666666',
                                    }}
                                  >
                                    {getBuyerIndividualValue?.PropertyDetails
                                      ?.propertyOtherDetails?.equipment || '-'}
                                  </Typography>
                                </Stack>
                                <Stack
                                  sx={{
                                    width: '100%',

                                    marginTop: '10px',
                                  }}
                                ></Stack>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            sx={{
                              background: '#FFFFFF',
                              paddingTop: '40px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: '24px',
                                color: '#000000',
                                marginTop: '30px',
                              }}
                            >
                              Video
                            </Typography>
                            <Grid container>
                              {videoTour?.propertyMedia ? (
                                <video
                                  controls
                                  style={{
                                    marginTop: '30px',
                                    borderRadius: '20px',
                                    objectFit: 'cover',
                                    width: matchessm
                                      ? '300px'
                                      : matchesmd
                                      ? '800px'
                                      : '1147px',
                                    height: matchessm
                                      ? '250px'
                                      : matchesmd
                                      ? '400px'
                                      : '600px',
                                    maxWidth: '100%',
                                  }}
                                >
                                  <source
                                    src={videoTour.propertyMedia}
                                    type="video/mp4"
                                  />
                                </video>
                              ) : (
                                <Typography
                                  sx={{
                                    mt: 4,
                                    textAlign: 'center',
                                    color: '#666',
                                    fontSize: '20px',
                                    fontFamily: 'Poppins',
                                  }}
                                >
                                  No Video Tour Uploaded
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            sx={{
                              background: '#FFFFFF',
                              paddingTop: '40px',
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: '24px',
                                color: '#000000',
                                marginTop: '30px',
                              }}
                            >
                              360 Degree Tour
                            </Typography>
                            <Grid container>
                              {video360?.propertyMedia ? (
                                <video
                                  controls
                                  style={{
                                    marginTop: '30px',
                                    borderRadius: '20px',
                                    objectFit: 'cover',
                                    width: matchessm
                                      ? '300px'
                                      : matchesmd
                                      ? '800px'
                                      : '1147px',
                                    height: matchessm
                                      ? '250px'
                                      : matchesmd
                                      ? '400px'
                                      : '600px',
                                    maxWidth: '100%',
                                  }}
                                >
                                  <source
                                    src={video360.propertyMedia}
                                    type="video/mp4"
                                  />
                                </video>
                              ) : (
                                <Typography
                                  sx={{
                                    mt: 4,
                                    textAlign: 'center',
                                    color: '#666',
                                    fontSize: '20px',
                                    fontFamily: 'Poppins',
                                  }}
                                >
                                  No 360 Video Uploaded
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                          <WalkScore
                            walkScore={
                              getBuyerIndividualValue?.PropertyDetails
                                ?.walkScore
                            }
                            address={
                              getBuyerIndividualValue?.PropertyDetails
                                ?.propertyAddress?.streetName
                            }
                            isMobile={matchessm}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            margin: '40px 0 100px 0',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.propertyOtherDetails?.isPublishLease == 1 && (
                            <Grid>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: matchesbet ? '18px' : '24px',
                                  color: '#000000',
                                }}
                              >
                                Lease Expiry : &nbsp;
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontSize: '18px',
                                    color: '#666666',
                                    fontWeight: 500,
                                  }}
                                >
                                  {leaseExpiryDate}
                                </Typography>
                              </Typography>
                            </Grid>
                          )}
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.propertyOtherDetails?.isPublishRent == 1 && (
                            <Grid>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: matchesbet ? '18px' : '24px',
                                  color: '#000000',
                                }}
                              >
                                Rental Price : &nbsp;
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontSize: '18px',
                                    color: '#666666',
                                    fontWeight: 500,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 500,
                                    }}
                                  >
                                    $
                                  </span>
                                  {getBuyerIndividualValue?.PropertyDetails
                                    ?.propertyOtherDetails?.rentalPrice
                                    ? Number(
                                        getBuyerIndividualValue.PropertyDetails
                                          .propertyOtherDetails.rentalPrice
                                      ).toLocaleString()
                                    : 'N/A'}
                                </Typography>
                              </Typography>
                            </Grid>
                          )}
                        </Box>
                      </Grid>
                    </>
                  )}
                  {showActivateTrade && (
                    <MarketPlace
                      isAuction={
                        propertyDetails?.generalCampaignDetails?.generalCampaign
                      }
                      auctionDetails={
                        getBuyerIndividualValue?.PropertyDetails?.auctionDetails
                      }
                      offerHistoryState={offerHistoryState}
                      setOfferHistoryState={setOfferHistoryState}
                      setShowPropertyTimer={setShowPropertyTimer}
                      showPropertyTimer={showPropertyTimer}
                      hideOthers={hideOthers}
                      SetHideOthers={SetHideOthers}
                      newTabData={newTabData}
                      setNewTabData={setNewTabData}
                      isStickyTimerStage={isStickyTimerStage}
                      showActivateTrade={showActivateTrade}
                      isStickyAddress={isStickyAddress}
                      setIsStickyAddress={setIsStickyAddress}
                      collapsed={collapsed}
                      propertyIds={propertyIds}
                      hideActivateTrade={hideActivateTrade}
                      setHideActivateTrade={setHideActivateTrade}
                      setShowActivateTrade={setShowActivateTrade}
                      hideConfirmBox={hideConfirmBox}
                      setHideConfirmBox={setHideConfirmBox}
                      getBuyerIndividualValue={getBuyerIndividualValue}
                      setGetBuyerIndividualValue={setGetBuyerIndividualValue}
                      tabData={tabData}
                      setTabDAta={setTabDAta}
                      groupIt={groupIt}
                      makeOfferRef={makeOfferRef}
                      activityfun={activityfun}
                      isStickyTimer={isStickyTimer}
                      stickyAnchorTimerRef={stickyAnchorTimerRef}
                      blurComp={blurComp}
                      setBlurComp={setBlurComp}
                      confirmAcceptLog={confirmAcceptLog}
                      setConfirmAcceptLog={setConfirmAcceptLog}
                      openlogin={openlogin}
                      setOpenlogin={setOpenlogin}
                      sharedpage={sharedpage}
                      isSticky={isSticky}
                      setIsSticky={setIsSticky}
                      matchesxl={matchesxl}
                      dateupdated={dateupdated}
                      onShowChat={onShowChat}
                      activityupdate={activityupdate}
                      directcomm={directcomm}
                      setIsHovered={setIsHovered}
                      handleMouseLeave={handleMouseLeave}
                      handleClick={handleClick}
                      isDialogOpen={isDialogOpen}
                      setDialogOpen={setDialogOpen}
                      isHovered={isHovered}
                      isBinderChatOpen={isBinderChatOpen}
                      setIsMakeanOffer={setIsMakeanOffer}
                      isMakeanOffer={isMakeanOffer}
                      handleMakeOfferClick={handleMakeOfferClick}
                      setPaymentPop={setPaymentPop}
                      paymentPop={paymentPop}
                      marketScrollRef={marketScrollRef}
                      pageRef={pageRef}
                      setScrollToMakeOffer={setScrollToMakeOffer}
                      scrollToMakeOffer={scrollToMakeOffer}
                      scrollTotabRef={scrollTotabRef}
                    />
                  )}
                </>
              )}

              <div ref={stickyAnchorRef} style={{ marginTop: '-200px' }} />
              {!matchesmd && (
                <>
                  <div className="highest-offer-page">
                    <HighestOffer
                      setOpenBuyerProtection={setOpenBuyerProtection}
                      isSticky={isSticky}
                      matchesxl={matchesxl}
                      showActivateTrade={showActivateTrade}
                      isStickyAddress={isStickyAddress}
                      blurComp={blurComp}
                      isStickyTimer={isStickyTimer}
                      confirmAcceptLog={confirmAcceptLog}
                      getBuyerIndividualValue={getBuyerIndividualValue}
                      dateupdated={dateupdated}
                      userDetail={userDetail}
                      setShowActivateTrade={setShowActivateTrade}
                      setHideActivateTrade={setHideActivateTrade}
                      setTabDAta={setTabDAta}
                      onShowChat={onShowChat}
                      activityupdate={activityupdate}
                      setIsMakeanOffer={setIsMakeanOffer}
                      sharedpage={sharedpage}
                      isOpenFileManager={isOpenFileManager}
                      setIsOpenFileManager={setIsOpenFileManager}
                      onMakeOfferClick={() => {
                        if (
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'Pause'
                        )
                          return;
                        setShowActivateTrade(true);
                        setHideActivateTrade(false);
                        setTabDAta('4');
                        setIsMakeanOffer(true);
                        setScrollToMakeOffer(true);
                      }}
                    />
                  </div>
                  <div className="highest-offer-height-spacer" />
                </>
              )}
            </Grid>
            {modalIsOpen && (
              <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />
            )}

            {!matcheslgIsSticky && highestOfferBox && (
              <Collapse sx={{ border: '1px solid red' }} in={highestOfferBox}>
                <Card
                  sx={{
                    position: 'absolute',
                    top: matchessm ? '630px' : matchesmd ? '630px' : '1050px',
                    right: 0,
                    background: 'white',
                    zIndex: 1000,
                    height: '100vh',
                    overflow: 'auto',
                  }}
                >
                  <Box
                    onClick={() => setHighestOfferBox(!highestOfferBox)}
                    sx={{ cursor: 'pointer', margin: '20px 10px' }}
                  >
                    <Expand />
                  </Box>
                  <HighestOffer1
                    isSticky={isSticky}
                    matchesxl={matchesxl}
                    showActivateTrade={showActivateTrade}
                    isStickyAddress={isStickyAddress}
                    blurComp={blurComp}
                    isStickyTimer={isStickyTimer}
                    confirmAcceptLog={confirmAcceptLog}
                    getBuyerIndividualValue={getBuyerIndividualValue}
                    dateupdated={dateupdated}
                    userDetail={userDetail}
                    setShowActivateTrade={setShowActivateTrade}
                    setHideActivateTrade={setHideActivateTrade}
                    setTabDAta={setTabDAta}
                    onShowChat={onShowChat}
                    activityupdate={activityupdate}
                    sharedpage={sharedpage}
                  />
                </Card>
              </Collapse>
            )}
          </Box>
          <Dialog
            open={auctionConfirm}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                minWidth: matchessm ? '95%' : '400px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: matchesmd ? '30px 20px' : '30px',
              },
            }}
          >
            <Grid container height={'100%'}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchesmd ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {
                    getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName
                  }
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                display={'flex'}
                alignItems={'center'}
                padding={'10px 0px'}
              >
                <Warning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '16px' : '24px',
                    paddingLeft: '12px',
                  }}
                >
                  Auction Invitation
                </Typography>
              </Grid>
              <Grid item md={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchesmd ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Would you like to attend the auction for this property?
                </Typography>
              </Grid>

              <Grid
                item
                container
                direction="row"
                justifyContent={'flex-end'}
                gap={2}
                marginTop={matchesmd ? 1 : 4}
              >
                <Grid item>
                  <Stack direction={'row '} alignItems={'center'}>
                    <Button
                      variant="outlined"
                      style={{
                        padding: matchessm ? '6px 23px' : '10px 39px',
                        width: '100%',
                        height: matchessm ? '35px' : '41px',
                        fontSize: matchessm ? '12px' : '14px',
                        color: '#666666',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        border: '1px solid rgba(17, 35, 71, 0.1)',
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                      }}
                      disabled={auctionDeclineLoading}
                      onClick={() => handleAuctionConfirm(0)}
                    >
                      Decline
                    </Button>
                    {auctionDeclineLoading && (
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{ height: '40px', width: '40px' }}
                      />
                    )}
                  </Stack>
                </Grid>
                <Grid item>
                  <Stack
                    direction={'row '}
                    alignItems={'center'}
                    justifyContent={'start'}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => handleAuctionConfirm(1)}
                      style={{
                        padding: matchessm ? '6px 23px' : '10px 39px',
                        width: '100%',
                        height: matchessm ? '35px' : '41px',
                        fontSize: matchessm ? '12px' : '14px',
                        color: '#FFFFFF',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        background: '#4CA4D6',
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                      }}
                      disabled={auctionConfirmLoading}
                    >
                      Confirm
                    </Button>
                    {auctionConfirmLoading && (
                      <Grid item>
                        <img
                          alt="Logo"
                          src={Loading}
                          className="loaderImage"
                          style={{ height: '40px', width: '40px' }}
                        />
                      </Grid>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
          <BuyerProtectionDialog
            open={openBuyerProtection}
            handleClose={() => setOpenBuyerProtection(false)}
            buyerProtectionLink={getBuyerIndividualValue?.buyerProtectionLink}
          />
          {sharedpage && openlogin && (
            <MarketInvitePopup
              open={openlogin}
              address={
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
              onClose={setOpenlogin}
              scrollPercentage={scrollTop}
              showActivateTradeForSharePage={showActivateTradeForSharePage}
              tabData={tabData}
            />
          )}
          {/* AI suggestion popups when there is identical offer  */}

          {firstIdentical == 1 &&
          getBuyerIndividualValue?.PropertyDetails?.timerStatus != 'End' ? (
            <IdenticalSuggestionBuyerone
              open={true}
              onClose={() => {
                setFirstIdentical(null);
              }}
              address={
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
              makeoffer={() => {
                setShowActivateTrade(true);
                setHideActivateTrade(false);
                setTabDAta('4');
                setIsMakeanOffer(true);
                window.scroll({
                  top: 2100,
                  behavior: 'smooth',
                });
              }}
              matchessm={matchessm}
              matchesmd={matchesmd}
            />
          ) : firstIdentical == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.timerStatus != 'End' ? (
            <IdenticalSuggestionBuyertwo
              open={true}
              onClose={() => {
                setFirstIdentical(null);
              }}
              address={
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
              makeoffer={() => {
                setShowActivateTrade(true);
                setHideActivateTrade(false);
                setTabDAta('4');
                setIsMakeanOffer(true);
                window.scroll({
                  top: 2100,
                  behavior: 'smooth',
                });
              }}
              matchessm={matchessm}
              matchesmd={matchesmd}
            />
          ) : null}
          {/* AI suggestion popups when there is identical offer closes  */}
        </>
      )}
    </div>
  );
};

export function HighestOffer({
  isSticky,
  matchesxl,
  showActivateTrade,
  isStickyAddress,
  blurComp,
  isStickyTimer,
  confirmAcceptLog,
  getBuyerIndividualValue,
  dateupdated,
  userDetail,
  setShowActivateTrade,
  setHideActivateTrade,
  setTabDAta,
  onShowChat,
  sharedpage,
  setIsMakeanOffer,
  activityupdate,
  onMakeOfferClick,
  isOpenFileManager,
  setIsOpenFileManager,
  setOpenBuyerProtection,
}) {
  const userType = JSON.parse(localStorage.getItem('userType'))?.userType;
  const [isHovered, setIsHovered] = useState(false);
  const [isConditionalHovered, setIsConditionalHovered] = useState(false);
  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
  };

  const containerConditionalStyle = {
    position: 'relative',
    display: 'inline-block',
  };

  const textStyle = {
    visibility: 'hidden',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    borderRadius: '6px',
    padding: '5px 10px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
  };

  const textConditionalStyle = {
    visibility: 'hidden',
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'center',
    borderRadius: '6px',
    padding: '15px 10px',
    position: 'absolute',
    zIndex: 1,
    bottom: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
  };

  const textVisibleStyle = {
    ...textStyle,
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.3s',
  };

  return (
    <Grid
      item
      sx={{
        top: isSticky ? 120 : 950,
        display: 'flex',
        flexDirection: 'column',
        scrollBehavior: 'smooth',
        zIndex: 10,
        background: 'white',
        paddingBottom: '10px',
        bottom: '10px',
        color: '#fff',
        fontSize: '2em',
        right: '50px',
        marginLeft: showActivateTrade ? '-35px' : '110px',
        marginTop: isStickyAddress ? '60px' : isSticky ? '60px' : '120px',
        position: isSticky ? 'fixed' : 'absolute',
        scrollbarWidth: 'none',
        overflowY: isSticky ? 'auto' : 'hidden',
        overflowX: 'hidden',
        height: '95%',
      }}
    >
      <MediaQuery minWidth={1330}>
        <Paper
          className="rightConetnt"
          style={{
            maxHeight: '95%',
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'auto',
          }}
          sx={{
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
          }}
        >
          <List sx={{ paddingTop: '0px' }}>
            <Stack
              sx={{
                width: '333px',
                height: '507px',
                backgroundColor: 'rgba(255, 255, 255, 0.77)',
                borderRadius: '5px',
                border: '0.5px solid #E4E4E4',
              }}
            >
              <Stack
                sx={{
                  marginLeft: '8px',
                  marginTop: '12px',
                  marginRight: '8px',
                  height: '59px',
                  background: '#F7F8F7',
                  borderRadius: '6px',
                  padding: '10px 10px 10px 10px',
                }}
              >
                <Typography
                  sx={{
                    textAlign: 'center',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '20px',
                    color: '#6C2AD2',
                  }}
                >
                  Highest Offer
                </Typography>
              </Stack>

              {getBuyerIndividualValue?.PropertyDetails?.highestOffer ? (
                <Stack sx={{ paddingTop: '20px' }} gap={1}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '30px',
                      color: '#112347',
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails
                      ?.highestOfferIsFinal == 1 && (
                      <div
                        style={containerStyle}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                      >
                        <HighStar style={highStarStyle} />
                        <span style={isHovered ? textVisibleStyle : textStyle}>
                          Best & Final Offer
                        </span>
                      </div>
                    )}{' '}
                    {`${
                      getBuyerIndividualValue?.PropertyDetails?.highestOffer ||
                      '-'
                    }`}
                    <sup>
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferIsConditional == 1 ? (
                        <div
                          style={containerConditionalStyle}
                          onMouseEnter={() => setIsConditionalHovered(true)}
                          onMouseLeave={() => setIsConditionalHovered(false)}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerCodeId ==
                          userDetail?.userAppId ? (
                            <Dot />
                          ) : (
                            ''
                          )}

                          <span
                            style={
                              isConditionalHovered
                                ? textVisibleStyle
                                : textConditionalStyle
                            }
                          >
                            Conditional
                          </span>
                        </div>
                      ) : getBuyerIndividualValue?.PropertyDetails
                          ?.highestOfferBuyerCodeId == userDetail?.userAppId ? (
                        <GreenDot />
                      ) : (
                        ''
                      )}
                    </sup>
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      color: 'rgba(17, 35, 71, 0.5)',

                      textAlign: 'center',
                    }}
                  >
                    Last Updated : &nbsp;
                    {dateupdated}
                  </Typography>

                  <Box
                    sx={{
                      fontFamily: 'Poppins',
                      fontStyle: 'normal',
                      fontWeight: 300,
                      fontSize: '16px',
                      color: '#112347',
                      marginTop: '3.33px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '7px',
                      width: '100%',
                      minWidth: 0,
                    }}
                  >
                    {userType == 'Buyer' &&
                    getBuyerIndividualValue?.PropertyDetails
                      ?.highestOfferBuyerCodeId != userDetail?.userAppId ? (
                      <Avatar
                        src={userIcon}
                        alt={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerName
                        }
                        sx={{
                          height: '36.5px',
                          width: '36.5px',
                          flexShrink: 0,
                        }}
                      />
                    ) : getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerProfile == '' ||
                      getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerProfile == null ? (
                      <Avatar
                        sx={{
                          width: '36px',
                          height: '36px',
                          backgroundColor: '#666666',
                          fontFamily: 'Poppins',
                          fontSize: '18px',
                          flexShrink: 0,
                        }}
                      >
                        {getBuyerIndividualValue?.PropertyDetails
                          ?.highestOfferBuyerNameInitial || ''}
                      </Avatar>
                    ) : (
                      <Avatar
                        src={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerProfile
                        }
                        alt={
                          getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerName
                        }
                        sx={{
                          height: '36.5px',
                          width: '36.5px',
                          flexShrink: 0,
                        }}
                      />
                    )}

                    {/* Name */}
                    <Box
                      sx={{
                        minWidth: 0,
                        maxWidth: 'calc(100% - 43px)',
                        overflow: 'hidden',
                      }}
                    >
                      {getBuyerIndividualValue?.PropertyDetails
                        ?.highestOfferBuyerCodeId === userDetail?.userAppId ? (
                        <NameTooltip
                          name={
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerName || ''
                          }
                        >
                          <Typography
                            component="span"
                            sx={{
                              display: 'block',
                              width: '100%',
                              minWidth: 0,
                              fontFamily: 'Poppins',
                              fontWeight: 300,
                              fontSize: '16px',
                              color: '#112347',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerName || ''}
                          </Typography>
                        </NameTooltip>
                      ) : getBuyerIndividualValue?.PropertyDetails?.stage ==
                        'ST2' ? (
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'Poppins',
                            fontWeight: 300,
                            fontSize: '16px',
                            color: '#112347',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerCodeId
                          }{' '}
                          (Not You)
                        </Typography>
                      ) : (
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'Poppins',
                            fontWeight: 300,
                            fontSize: '16px',
                            color: '#112347',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferUniqueId
                          }{' '}
                          (Not You)
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Stack>
              ) : (
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: '16px',
                    color: '#112347',
                    padding: '20px',
                    mt: '30px',
                    textAlign: 'center',
                  }}
                >
                  Not available
                </Typography>
              )}

              <Grid
                container
                direction={'row'}
                spacing={'2'}
                marginTop={'5%'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Clock />
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '16px',
                    color: '#212529',
                    marginLeft: '11px',
                  }}
                >
                  Offers close in:
                </Typography>
              </Grid>
              <Card
                sx={{
                  marginLeft: '15px',
                  marginTop: '15px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '151px',
                  width: '300px',
                  background: '#FFFFFF',
                  boxShadow: 'none',
                  letterSpacing: '1%',
                }}
              >
                <PropertyTimer
                  propertyData={getBuyerIndividualValue?.PropertyDetails}
                  timerStatus={
                    getBuyerIndividualValue?.PropertyDetails?.timerStatus
                  }
                  stage={getBuyerIndividualValue?.PropertyDetails?.stage}
                  isReset={getBuyerIndividualValue?.PropertyDetails?.isReset}
                />
              </Card>
              {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
                <Button
                  sx={{
                    textTransform: 'none',
                    width: '162px',
                    height: '43px',
                    borderRadius: '5px',
                    bgcolor:
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                      'Pause'
                        ? '#C4C4C4'
                        : '#33A745',
                    alignSelf: 'center',
                    color: '#FFFFFF',
                    ...poppins500,
                    fontSize: '16px',
                    cursor:
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                      'Pause'
                        ? 'not-allowed'
                        : 'pointer',
                    '&:hover': {
                      bgcolor:
                        getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                        'Pause'
                          ? '#C4C4C4'
                          : '#33A745',
                      color: '#FFFFFF',
                      boxShadow: 'none',
                    },
                    '&.Mui-disabled': {
                      color: '#FFFFFF',
                    },
                  }}
                  onClick={() => {
                    if (isOpenFileManager) {
                      setIsOpenFileManager(false);
                    }
                    onMakeOfferClick?.();
                  }}
                >
                  Make an Offer
                </Button>
              )}
            </Stack>
            <Grid
              container
              sx={{
                marginTop: '20px',
                width: '326px',
                height: '224px',
                background: '#FFFFFF',
                borderRadius: '5px',
                border: '0.5px solid #E4E4E4',
              }}
            >
              <Grid container spacing={'1'}>
                <Grid item xs={8} sx={{ marginTop: '5px' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '16px',
                      color: '#000000',

                      marginLeft: '15px',
                    }}
                  >
                    retreX Buyer Protection
                  </Typography>
                  <Stack direction={'column'} spacing={'1'}>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Offer}
                        alt="Exchange"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Transparent Offering
                      </Typography>
                    </Stack>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Exchange}
                        alt="Exchange"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Instant Exchange<sup>*</sup>
                      </Typography>
                    </Stack>
                    <Stack
                      direction={'row'}
                      spacing={1}
                      alignItems={'center'}
                      paddingTop={'8px'}
                      paddingLeft={'15px'}
                    >
                      <img
                        src={Man}
                        alt="Man"
                        style={{
                          width: '30px',
                          height: '30px',
                          marginTop: '5px',
                          marginLeft: '5px',
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          color: '#112347',
                        }}
                      >
                        Anonymous & Secure
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction={'column'} marginLeft={'20px'}>
                    <Shield />
                  </Stack>
                </Grid>
              </Grid>
              <Stack sx={{ paddingLeft: '20px' }}>
                <Typography
                  onClick={() => setOpenBuyerProtection(true)}
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: '12px',
                    color: '#6C2AD2',
                    lineHeight: '18px',
                    cursor: 'pointer',
                    width: 'fit-content',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Learn more about retreX Buyer Protection
                </Typography>
              </Stack>
            </Grid>
            {!sharedpage && (
              <Stack
                sx={{
                  width: '326px',
                  maxHeight: 'auto',
                  minHeight: '500px',
                  overflow: 'scroll',
                  background: '#FFFFFF',
                  alignContent: 'center',
                  marginY: '20px',
                }}
              >
                <MessagingContainer
                  onShowChat={onShowChat}
                  binders={true}
                  market={true}
                  activityupdate={activityupdate}
                />
              </Stack>
            )}
          </List>
        </Paper>
      </MediaQuery>
    </Grid>
  );
}
export default Market;
